import React from 'react';
import { Section } from './Section';
import { CTAButton } from './CTAButton';
export function FinalCTA() {
  return <Section className="relative overflow-hidden bg-ink-950" data-id="element-109" data-mp="3udfc7a8y1rnh">
      <div aria-hidden="true" className="pointer-events-none absolute left-1/2 top-1/2 h-[32rem] w-[32rem] -translate-x-1/2 -translate-y-1/2 rounded-full bg-accent/12 blur-[150px]" data-id="element-110" data-mp="c6sldjejycdw" />
      <div className="relative" data-id="element-111" data-mp="87jrmejiieic">
        <p className="mb-3 text-xs font-semibold uppercase tracking-[0.22em] text-accent-soft" data-id="element-112" data-mp="m4f0a5vuq3xv">
          Una última cosa antes de que te vayas
        </p>
        <h2 className="text-3xl font-extrabold leading-[1.12] tracking-tight text-white sm:text-4xl" data-id="element-113" data-mp="h3repzqe6fb1">
          Tu iPhone ya tiene todo lo que necesitas. Solo falta que aprendas a
          usarlo.
        </h2>

        <div className="mt-7 space-y-4 text-base leading-relaxed text-white/65 sm:text-lg" data-id="element-114" data-mp="qy17vjn5rhmt">
          <p data-id="element-115" data-mp="14t3k0oilm382">Piénsalo un momento.</p>
          <p data-id="element-116" data-mp="zwv77hrvim42">
            Tienes en tu bolsillo uno de los dispositivos más potentes que
            existe. Un aparato que costó mucho dinero. Un celular que puede
            organizar tu vida, proteger tus recuerdos, mejorar tu trabajo,
            ahorrar tiempo y hacer cosas increíbles.
          </p>
          <p className="text-white" data-id="element-117" data-mp="2m2ksm66v0ycr">
            Y hoy lo estás usando al 20% de su potencial.
          </p>
          <p data-id="element-118" data-mp="2r2yq4uau4pwj">
            No porque seas descuidado. No porque no te importe. Sino porque
            nadie te enseñó cómo hacerlo de forma simple, ordenada y completa.
          </p>
          <p className="text-white" data-id="element-119" data-mp="301tyod1cqc30">iPhone Experto existe para cambiar eso.</p>
          <p data-id="element-120" data-mp="34tlrku7zctwb">
            Para que la próxima vez que alguien te vea usar tu celular, no estés
            scrolleando sin rumbo, sino aprovechando cada función, cada ajuste,
            cada herramienta que Apple puso en ese aparato para ti.
          </p>
          <p data-id="element-121" data-mp="3et2skycaejly">
            Para que dejes de sentir que pagaste mucho por algo que no entiendes
            del todo.
          </p>
          <p data-id="element-122" data-mp="1jocy0dxsczwj">
            Para que uses tu iPhone con confianza, con control y con la
            sensación de que por fin lo dominas de verdad.
          </p>
          <p className="text-xl font-extrabold text-white sm:text-2xl" data-id="element-123" data-mp="1eqtkxhctqt66">
            El momento de empezar es ahora.
          </p>
          <p data-id="element-124" data-mp="1sihw9if91dm3">No mañana. No cuando «tengas más tiempo». Ahora.</p>
          <p data-id="element-125" data-mp="1np59zey1liwi">
            Porque en unos minutos ya podrías estar aplicando los primeros
            trucos, configurando mejor tu batería, descubriendo funciones que no
            sabías que tenías y sintiendo que este iPhone que compraste, por
            fin, vale cada peso que pagaste.
          </p>
          <p className="font-semibold text-white" data-id="element-126" data-mp="2bezl9s2pqzen">Haz clic abajo y empieza hoy.</p>
        </div>

        <div className="mt-10" data-id="element-127" data-mp="27efo4oi53vsi">
          <CTAButton className="items-center" note="Acceso inmediato después de tu compra. Sin esperas. Sin complicaciones." data-id="element-128" data-mp="27c3agnjf07l9" />
        </div>
      </div>
    </Section>;
}